import BaseButton from '@/components/BaseButton'
import { Modal } from 'bootstrap'

export default {

  components: {
    BaseButton
  },

  data () {
    return {
      profiles: [],
      permissions: [],
      error: false,
      responseErr: '',
      actionElement: null,
      isProcessing: false
    }
  },

  created () {
    this.getProfiles()
  },

  methods: {
    async getProfiles () {
      this.isProcessing = true
      this.error = false

      this.$store.dispatch('profiles/list').then(
        response => {
          this.profiles = response.profiles
          this.isProcessing = false
        },
        error => {
          error = true
          this.responseErr = error || 'error.BAD_REQUEST'
        }
      )
    },
    showPermissions (permissions) {
      this.permissions = permissions
    },
    getPermissionInfo (permission) {
      return this.$i18n.t('label.profile.permission.'.concat(permission.replace(':', '_')))
    },
    async editProfile (profile) {
      this.$store.dispatch('profiles/setProfile', profile)
      this.$router.push({ name: 'profile-edit' })
    },
    async deleteProfile () {
      this.isProcessing = true
      this.responseErr = null
      let successMsg = null

      this.$store.dispatch('profiles/delete', {
        roleName: this.actionElement.id
      }).then(
        () => {
          successMsg = this.$i18n.t('label.profile.profileDeletedSuccess', [this.actionElement.id] )
          this.showSuccess(successMsg)
          this.profiles.splice(this.profiles.indexOf(this.actionElement), 1)
          this.isProcessing = false
          // this.$router.push({ name: 'profile-list' })
        },
        error => {
          this.error = true
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
          this.showError(error.response ? error.reponse.data : 'BAD_REQUEST')
        }
      )
    },

    showError (msg) {
      let errorModal = new Modal(document.getElementById('errorModal'))
      errorModal.show()
      document.getElementById('errorModalMsg').innerHTML = this.$i18n.t('error.' + msg)
    },

    showSuccess (msg) {
      let successModal = new Modal(document.getElementById('successModal'))
      successModal.show()
      document.getElementById('successModalMsg').innerHTML = msg
    },

    showConfirmation (element, calledAction) {
      this.actionElement = element
      this.confirmedAction = calledAction
      let confirmationModal = new Modal(document.getElementById('confirmationModal'))
      confirmationModal.show()
    },

    executeConfirmedAction () {
      this.confirmedAction()
    }
  }
}
